var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-inline-flex align-center" },
    [
      _c("span", { staticClass: "locomotion-filter-label mr-3" }, [
        _vm._v(_vm._s(_vm.term("station.locomotion"))),
      ]),
      _vm._v(" "),
      _c(
        "v-btn-toggle",
        {
          attrs: {
            value: _vm.locomotion,
            mandatory: "",
            dense: "",
            color: "primary",
            "data-testid": "locomotion-filter",
            "aria-label": _vm.term("station.locomotion_filter.label"),
          },
          on: {
            change: function (value) {
              return _vm.$emit("change", value)
            },
          },
        },
        _vm._l(_vm.options, function (option) {
          return _c(
            "v-btn",
            { key: option.value, attrs: { value: option.value, small: "" } },
            [_vm._v(_vm._s(option.label))]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }